import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, useLocation, Routes, Navigate, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { StudentDataProvider } from "../context/studentContext";
import LoginPage from "./UserPages/Login"
import ForgotPassword from "./UserPages/ForgotPassword";
import PasswordReset from "./UserPages/PasswordReset";
import ParentalConsent from "./UserPages/ParentalConsent";
import PasswordExpired from "./UserPages/PasswordExpired";
import usePersonAuthStore from './store/personAuthStore'
import { SelectedPersonProvider } from "../context/SelectedPersonContext";
import { StaffIndexPage } from "./StaffPages/StaffRoutes";
import { StudentIndexPage } from "./StudentPages/StudentRoutes";
import ManageModal, { ManageModalProvider } from "./Manage/components/ManageModal/ManageModal";
import { DashboardIndexPage } from "./DashboardPages";
import { useInterval } from 'ft-common';
import { SelectedStudentProvider } from "./StudentPages/hooks";
import { CompanyIndexPage } from "./CompanyPages/CompanyRoutes";
const RenderRoutes = () => {
  const accessToken = usePersonAuthStore(state => state.access_token);
  const roles = usePersonAuthStore(state => state.roles);
  const setAuthValuesFromAccessToken = usePersonAuthStore(state => state.setAuthValuesFromAccessToken);

  useEffect(() => {
    if (!accessToken || roles.length > 0) {
      return
    }

    setAuthValuesFromAccessToken(accessToken)
  }, [accessToken]);
  return (
    <Box
      component="div"
      sx={{
        backgroundColor: "#F3F6F9",
        minHeight: "100vh",
      }}
    >
      <Router>
        <StudentDataProvider>
          <SelectedPersonProvider>
            <ManageModalProvider>
              <SelectedStudentProvider>
                <ManageModal />
                <Routes>
                  <Route path="login" element={<LoginPage />} />
                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route path="password-expired/:email" element={<PasswordExpired />} />
                  <Route path="password-reset/:email" element={<PasswordReset />} />
                  <Route path="parental-consent/*" element={<ParentalConsent />} />
                  <Route path="manage/children/*" element={<StudentIndexPage />} />
                  <Route path="manage/users/*" element={<StaffIndexPage />} />
                  <Route path="manage/company/*" element={<CompanyIndexPage />} />
                  <Route path="dashboard/*" element={<DashboardIndexPage />} />
                  <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
              </SelectedStudentProvider>
            </ManageModalProvider>
          </SelectedPersonProvider>
        </StudentDataProvider>
        <AuthenticationMonitor />
      </Router>
    </Box>
  );
};

function AuthenticationMonitor() {
  var navigate = useNavigate();
  var location = useLocation();

  const accessToken = usePersonAuthStore(state => state.access_token);
  const destory = usePersonAuthStore(state => state.destroy);

  // useEffect(() => {
  //   console.log('History ', location.pathname);
  // }, [location]);

  useInterval(() => {
    if (!accessToken) return;

    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    if (location.pathname !== '/' && Date.now() >= (payload.exp * 1000)) {
      destory();
      navigate('/', { replace: true });
    }
  }, 1000);

  return null;
}

export default RenderRoutes;
